(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name manageFlights.factory:ManageFlightsRequestFactory
     *
     * @description
     *
     */
    angular
        .module('messageInbox')
        .factory('MessageInboxFactory', MessageInboxFactory);

    function MessageInboxFactory() {

        function SearchMessageInboxRequest() {
            this.fromDate = null;
            this.toDate= null;
            this.category = null;
            this.sentByType = null;
            this.crewType = null;
            this.sentByUserId = null;
            this.title = null;
            this.pageSize = null;
            this.startPosition = null;
        }

        function MarkAsReadRequest() {
        	this.messageId = null;
            this.messageUserId = null;
        }

        function SetSelectedFlag(crewList){
        	if(!!crewList){
        		crewList.forEach(function(crew) {
        			crew.isSelected = false;
        			crew.isRemoved = false;
        			crew.hide = false;
        		});
        	}
        	return crewList;
        }

        function getPriorityListObject(priorityList) {
        	var priorityListObj = {};
        	angular.forEach(priorityList, function(priorityObj){
        		priorityListObj[priorityObj.value] = priorityObj.priority;
        	});
        	return priorityListObj;
        }

        var searchMessageInboxRQ = function (searchParams) {
            var searchMessageInbox = new SearchMessageInboxRequest();
            searchMessageInbox.fromDate = searchParams.fromDate;
            searchMessageInbox.toDate = searchParams.toDate;
            searchMessageInbox.category = angular.isUndefined(searchParams.category) ? null : searchParams.category.messageCategoryCode ;
            searchMessageInbox.sentByType = angular.isUndefined(searchParams.sentBy) ? null : searchParams.sentBy.value ;
            searchMessageInbox.crewType = angular.isUndefined(searchParams.crewType) ? null : searchParams.crewType.crewTypeCode;
            searchMessageInbox.sentByUserId = angular.isUndefined(searchParams.sentByUserId) ? null : searchParams.sentByUserId.crewId;
            searchMessageInbox.includeReadMsgs = searchParams.includeReadMsgs;
            searchMessageInbox.title = searchParams.title;
            searchMessageInbox.pageSize = searchParams.pageSize;
            searchMessageInbox.startPosition = searchParams.startPosition;
            return searchMessageInbox;
        };

        var getFormattedMessageList = function(messageList, priorityList) {
        	var priorityListObj = getPriorityListObject(priorityList);
        	angular.forEach(messageList.list, function(message){
        		message.priority = priorityListObj[message.priority];
        	});
        	return messageList;
        }

        var markAsReadRQ = function (requestParams) {
            var markAsRead = new MarkAsReadRequest();
            markAsRead.messageId = requestParams.messageId;
            markAsRead.messageUserId = requestParams.messageUserId;
            return markAsRead;
        };
        
        var deleteMessageRQ = function(messageId) {
        	return {
        		messageId : messageId
        	}
        }

        return{
        	searchMessageInboxRQ : searchMessageInboxRQ,
        	markAsReadRQ : markAsReadRQ,
        	setSelectedFlag : SetSelectedFlag,
        	getFormattedMessageList : getFormattedMessageList,
        	deleteMessageRQ : deleteMessageRQ
        }
    }
})();
